import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('PreviewOpen', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M24,36 C31.3637967,36 38.0304633,32 44,24 C38.0304633,16 31.3637967,12 24,12 C16.6362033,12 9.96953667,16 4,24 C9.96953667,32 16.6362033,36 24,36 Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("circle", {
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin,
    fill: props.innerFillColor,
    fillRule: "nonzero",
    cx: "24",
    cy: "24",
    r: "5"
  })));
});